import React from "react";

const SvgLike = props => <svg width={22} height={22} viewBox="0 0 22 22" {...props}><g fill="currentColor" fillRule="evenodd"><path d="M11 17l-.87-.78C7.04 13.4 5 11.57 5 9.3 5 7.44 6.44 6 8.3 6c1.05 0 2.04.48 2.7 1.26A3.56 3.56 0 0 1 13.7 6C15.56 6 17 7.44 17 9.3c0 2.27-2.04 4.1-5.13 6.92L11 17z" /></g></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/like_e874a4.svg";
export { SvgLike as ReactComponent };